import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpParams, HttpRequest, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {NotificationService} from "./notification.service";
import {APP_VERSION} from "../version";

@Injectable()
export class HttpVersionInterceptor implements HttpInterceptor {

    versionNotifications = {};

    constructor(private dialogService: NotificationService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // FIXME: hack to avoid https://github.com/angular/angular/issues/18812
        const params = new HttpParams({fromString: req.params.toString()});
        req = req.clone({
            params: params
                .append('_t', (new Date()).getTime() + '')
                .append('_v', APP_VERSION),
        });
        return next.handle(req)
            .pipe(
                map((event: HttpEvent<any>) => {
                    if (event instanceof HttpResponse) {
                        const response = event as HttpResponse<any>;
                        const version = response.headers.get('X-App-Version');
                        if (!!version && version !== APP_VERSION && version !== 'HEAD-SNAPSHOT') {
                            if (this.versionNotifications[version]) {
                                return;
                            }
                            console.error(`Version mismatch: ${APP_VERSION} : ${version}`);
                            if (window.confirm(`Existe uma nova versão da página ${version} (atual: ${APP_VERSION}), deseja atualizar?.`))
                                window.location.reload(true);
                            this.versionNotifications[version] = true;
                        }
                    }
                    return event;
                })
            );
    }

}
